import Vue from 'vue'

Vue.filter('price', function (value) {
  if (value || value === 0) {
    let splitValue = value.toString().split('.')
    let newValue = ''

    for (let i = splitValue[0].length - 1; i >= 0; i--) {
      newValue = splitValue[0][i] + newValue
      if (i > 0 && newValue.replace('.', '').length % 3 === 0) newValue = '.' + newValue
    }

    if (!splitValue[1]) newValue += ',00'
    else if (splitValue[1].length === 1) newValue += ',' + splitValue[1] + '0'
    else newValue += ',' + splitValue[1].substr(0, 2)

    return 'R$ ' + newValue
  } else {
    return value
  }
})

Vue.filter('priceInteger', function (value) {
  if (value || value === 0) {
    let splitValue = value.toString().split('.')
    let newValue = ''

    for (let i = splitValue[0].length - 1; i >= 0; i--) {
      newValue = splitValue[0][i] + newValue
      if (i > 0 && newValue.replace('.', '').length % 3 === 0) newValue = '.' + newValue
    }

    return newValue
  } else {
    return value
  }
})

Vue.filter('priceCents', function (value) {
  if (value || value === 0) {
    let splitValue = value.toString().split('.')
    let newValue = ''

    if (!splitValue[1]) newValue += '00'
    else if (splitValue[1].length === 1) newValue += splitValue[1] + '0'
    else newValue += splitValue[1].substr(0, 2)

    return newValue
  } else {
    return value
  }
})

Vue.filter('numberWithDots', function (value) {
  if (value || value === 0) {
    let stringValue = value.toString()
    let newValue = ''

    for (let i = stringValue.length - 1; i >= 0; i--) {
      newValue = stringValue[i] + newValue
      if (i > 0 && newValue.replace('.', '').length % 3 === 0) newValue = '.' + newValue
    }

    return newValue
  } else {
    return value
  }
})

Vue.filter('document', function (value) {
  if (value) {
    let stringValue = value.toString()
    if (stringValue.length === 11) {
      stringValue = stringValue.substr(0, 3) + '.' + stringValue.substr(3, 3) + '.' + stringValue.substr(6, 3) + '-' + stringValue.substr(9, 2)
    } else {
      stringValue = stringValue.substr(0, 2) + '.' + stringValue.substr(2, 3) + '.' + stringValue.substr(5, 3) + '/' + stringValue.substr(8, 4) + '-' + stringValue.substr(12, 2)
    }
    return stringValue
  } else {
    return value
  }
})
